<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters" size="mini">
				<!--el-form-item 自定义label  -->
				<el-form-item label="项目名称" >
					<el-cascader  :options="projectList" :props="defaultProps" collapse-tags :show-all-levels="false" clearable filterable v-model="filters.projectId" style="width:350px" ></el-cascader>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.mnCode" placeholder="设备编码"></el-input>
				</el-form-item>
				<el-form-item>
					<my-button  @select-type="clickBtn" QueryButtonShow AddButtonShow SettingButtonShow ExportButtonShow btnCon="设置项目" ></my-button>
				</el-form-item>
				<!-- <el-form-item>
					<import-button  @select-type="importVisible = true" v-if="fatherUserId==0"></import-button>
				</el-form-item> -->
				<el-form-item>
					<el-button type="primary"  icon="el-icon-setting" v-on:click="showSsr" v-if="fatherUserId==0">设置声源识别</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="devices" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;" border  :height="formHeight" size="mini">
			<el-table-column type="selection">
			</el-table-column>
			<el-table-column type="index" label="序号">
			</el-table-column>
			<el-table-column prop="name" label="名称" sortable>
			</el-table-column>
			<el-table-column prop="mnCode" label="设备编码"  sortable min-width="120">
			</el-table-column>
			<el-table-column prop="projectName" label="项目"   sortable>
			</el-table-column>
            <el-table-column prop="longitude" label="经度">
			</el-table-column>
            <el-table-column prop="latitude" label="纬度" >
			</el-table-column>
			<el-table-column prop="deviceTypeName" label="类型"  sortable>
			</el-table-column>
			<el-table-column prop="areaWeight" label="面积权重">
			</el-table-column>
			<el-table-column prop="ssr" label="声源识别" >
				<template slot-scope="scope">
					<span v-if="scope.row.ssr==1">是</span>
					<span v-else>否</span>
				</template>
			</el-table-column>
			<el-table-column prop="minuteFirstDate" label="开始时间" min-width="150" >
			</el-table-column>
			<el-table-column label="操作" width="350">
				<template slot-scope="scope">
					<el-button type="text" plain  icon="el-icon-upload" @click="uploadPic(scope.$index, scope.row)">上传照片</el-button>
					<table-update-button  @select-type="handleEdit(scope.$index, scope.row)" ></table-update-button>
					<table-setting-button  @select-type="showForm(scope.$index, scope.row)" btnCon="参数设置" >  </table-setting-button>
					<table-delete-button  @select-type="handleDel(scope.$index, scope.row)"  v-if="usertype==0"></table-delete-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;" :page-sizes="[20,50,100,200]"   @size-change="handleSizeChange" :current-page.sync="page">
			</el-pagination>
		</el-col>

		<!--From界面-->
		<el-dialog :title="type" :visible.sync="formVisible" :close-on-click-modal="false" width="60%" top="5vh">
			<div class="formStyle">
				<el-form :model="formdevice" label-width="120px" :rules="formRules" ref="formdevice" >
					<el-form-item label="名称" prop="name">
						<el-input v-model="formdevice.name" ></el-input>
					</el-form-item>
					<el-form-item label="设备编码" prop="mnCode" >
						<div v-if='type=="修改"'>
							<el-input v-model="formdevice.mnCode"  :disabled="true"></el-input>
						</div>
						<div v-else>
							<el-input v-model="formdevice.mnCode" ></el-input>
						</div>
					</el-form-item>
					<el-form-item label="经度"  prop="longitude" style="width:40%;display: inline-block;">
						<el-input v-model="formdevice.longitude" type="number" ></el-input>
					</el-form-item>
					<el-form-item label="纬度"  prop="latitude" style="width:40%;display: inline-block;">
						<el-input v-model="formdevice.latitude" type="number" ></el-input>
					</el-form-item>
					<el-form-item label="项目"  prop="projectId">
						<el-cascader  :options="projectList" :props="defaultPropsSingle"  :show-all-levels="false" clearable filterable v-model="formdevice.projectId" ></el-cascader>
						<!-- <el-select v-model="formdevice.projectId" placeholder="请选择项目" filterable>
							<el-option
								v-for="item in projectList"
								:label="item.name"
								:value="item.projectId" :key="item.projectId">
							</el-option>
						</el-select> -->
					</el-form-item>
					<el-form-item label="功能区"  prop="functionalAreaId">
						<el-select v-model="formdevice.functionalAreaId" placeholder="请选择功能区" filterable>
							<el-option
								v-for="item in areaList"
								:label="item.name"
								:value="item.id" :key="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="运维公司"  prop="operationCompanyId">
						<el-select v-model="formdevice.operationCompanyId" placeholder="请选择运维公司" filterable>
							<el-option
								v-for="item in operationcompanyList" :label="item.name" :value="item.id" :key="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="运维号码"  prop="operationCompanyPhone" style="width:40%;display: inline-block;">
						<el-input v-model="formdevice.operationCompanyPhone"   type="number" ></el-input>
					</el-form-item>
					<el-form-item label="运维周期（天）"  prop="operationCompanyCycle" style="width:40%;display: inline-block;">
						<el-input v-model="formdevice.operationCompanyCycle" type="number" ></el-input>
					</el-form-item>
					<el-form-item label="生产厂商"  prop="manufacturerName">
						<el-input v-model="formdevice.manufacturerName" ></el-input>
					</el-form-item>
					<el-form-item label="开始时间" prop="minuteFirstDate">
						<el-date-picker v-model="formdevice.minuteFirstDate" align="right" type="datetime" format="yyyy-MM-dd HH:mm:ss" :disabled="type=='修改'?true:false"> </el-date-picker>
					</el-form-item>
					<el-form-item label="类型" prop="deviceTypeId">
						<div v-if='type=="修改"'>
							<el-select v-model="formdevice.deviceTypeId" placeholder="请选择类型"  :disabled="true">
								<el-option
									v-for="item in deviceTypeList"
									:label="item.name"
									:value="item.deviceTypeId" :key="item.deviceTypeId">
								</el-option>
							</el-select>
						</div>
						<div v-else>
							<el-select v-model="formdevice.deviceTypeId" placeholder="请选择类型">
								<el-option
									v-for="item in deviceTypeList"
									:label="item.name"
									:value="item.deviceTypeId" :key="item.deviceTypeId">
								</el-option>
							</el-select>
						</div>
					</el-form-item>
					<el-form-item label="面积权重"  prop="areaWeight">
						<el-input v-model="formdevice.areaWeight" type="number" ></el-input>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click.native="cancleSubmit">取消</el-button>
					<el-button type="primary" @click.native="submitData" :loading="loading">提交</el-button>
				</div>
			</div>
		</el-dialog>

		<!--Form界面-->
		<el-dialog title="设置项目" :visible.sync="projectVisible" :close-on-click-modal="false">
			<el-form :model="formProject" label-width="80px" ref="formProject">
				<el-form-item label="项目" prop="project">
					<el-select v-model="formProject.project" placeholder="请选择项目" filterable>
						<el-option
							v-for="item in projectAllList"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSubmit">取消</el-button>
				<el-button type="primary" @click.native="setProject" :loading="loading">提交</el-button>
			</div>
		</el-dialog>

		<el-dialog title="设置声源识别" :visible.sync="ssrVisible" :close-on-click-modal="false">
			<el-form  label-width="80px" >
				<el-form-item label="声源识别">
					<el-radio-group v-model="ssr" placeholder="请选择声源识别">
						<el-radio label="1">是</el-radio>
						<el-radio label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSubmit">取消</el-button>
				<el-button type="primary" @click.native="setSSR" :loading="loading">提交</el-button>
			</div>
		</el-dialog>

		<el-dialog title="上传图片" :visible.sync="picVisible" :close-on-click-modal="false">
			<el-upload class="upload-demo" action="#" :http-request="httpRequest" ref="upload" name="file"
			:on-change="change" :on-remove="remove" accept="image/*" :file-list="fileListShow" 
			list-type="picture" multiple :auto-upload="false">
			<el-button size="small" type="primary">点击上传</el-button>
			<div slot="tip" class="el-upload__tip">只能上传图片文件，且最好不超过500kb</div>
			</el-upload>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSubmit">取消</el-button>
				<el-button type="primary" @click.native="submitUpload" :loading="loading">提交</el-button>
			</div>
		</el-dialog>

		<el-dialog title="导入表格修改设备信息" :visible.sync="importVisible" :close-on-click-modal="false">

			坐标类型：<el-select v-model="mapType" placeholder="请选择坐标类型" style="margin-bottom:20px">
				<el-option label="现场测量" value="device" > </el-option>
				<el-option label="百度地图（平台导出）" value="baidu" > </el-option>
			</el-select>

			<el-upload class="upload-demo" action="#" :http-request="httpRequest" ref="upload" name="file"
			:on-change="change" :on-remove="remove" accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" :file-list="fileListShow" 
			list-type="text" :auto-upload="false" >
			<el-button size="small" type="primary">点击上传</el-button>
			<div slot="tip" class="el-upload__tip">根据设备编码修改设备名称和经纬度</div>
			<div slot="tip" class="el-upload__tip">表头固定为：设备名称、设备编码、经度、纬度，其余信息不做处理</div>
			</el-upload>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSubmit">取消</el-button>
				<el-button type="primary" @click.native="importExcle" :loading="loading">提交</el-button>
			</div>
		</el-dialog>

		<el-dialog title="参数设置" :visible.sync="paramVisible" :close-on-click-modal="false">
			<el-table :data="paramsSys" highlight-current-row  v-loading="listLoading" style="width:100%;margin-bottom:50px">
				<el-table-column type="index" label="序号" width="80">
				</el-table-column>
				<el-table-column prop="name" label="参数名称">
				</el-table-column>
				<el-table-column prop="value" label="参数值">
					<template  slot-scope="scope">
						<el-input size="small" v-model="scope.row.value" ></el-input> 
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<table-query-button  @select-type="readHandle(scope.row)"  btnCon="读取"></table-query-button>
						<table-update-button  @select-type="writeHandle(scope.row)"  btnCon="写入"></table-update-button>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>

	</section>
</template>

<script>
	import axios from 'axios';
	import {addDevice,updateDevice,deleteDevices,getDeviceList,getDeviceTypes, getProjects,setProject,getDevicePic,uploadFile,
		downloadFileBlob,importExcle,getFunctionalAreaList,getOperationCompanyList,getParam,setSSR,setParams,getParams} 
		from '../../api/api';
	import {formatDate,translateDataToTreeProject } from '../../../static/fun.js';

	import myButton from '../../components/myButton/index.vue'
	import ImportButton from '../../components/myButton/ImportButton.vue'
	import ExportButton from '../../components/myButton/ExportButton.vue'
	import TableUpdateButton from '../../components/myButton/TableUpdateButton.vue'
	import TableSettingButton from '../../components/myButton/TableSettingButton.vue'
	import TableDeleteButton from '../../components/myButton/TableDeleteButton.vue'
	import TableQueryButton from '../../components/myButton/TableQueryButton.vue'

	export default {
	components: { myButton,TableUpdateButton,ImportButton,ExportButton,TableSettingButton,TableDeleteButton,TableQueryButton},
		data() {
			return {
				filters: {
                    mnCode: '',
					projectId:""
				},
				devices: [],
				total: 0,
               	page:1,
				pageSize:50,
				listLoading: false,
				sels: [],//列表选中列
				smallMap:{},
				keyword:'',

				formVisible: false,//修改界面是否显示
				projectVisible: false,//设置项目界面是否显示
				deviceTypeList:[],//设备类型列表
				projectList:[],//项目列表
				projectAllList:[],
				factorList:[],//附加因子列表
				facShow:false,//附加因子是否显示
				loading: false,
				mapRender:false,//地图是否加载
                formRules: {
					name: [
                        { required: true, message: '请输入名称', trigger: 'blur' }
					],
					areaWeight: [
                        { required: true, message: '请输入面积权重', trigger: 'blur' }
					],
					mnCode: [
						{ required: true, message: '请输入设备编码', trigger: 'blur' },
						{ min: 14, max: 32, message: '长度必须14-32个字符', trigger: 'blur' }
					],
					longitude:[
						{ required: true, message: '请输入经度', trigger: 'blur' }
					],
					latitude:[
                        { required: true, message: '请输入纬度', trigger: 'blur' }
                    ],
                    projectId: [
						{  required: true, message: '请选择项目', trigger: 'change'}
					],
                    deviceTypeId: [
						{  required: true, message: '请选择设备类型', trigger: 'change'}
					],
                    minuteFirstDate: [
						{  required: true, message: '请选择时间', trigger: 'change'}
					]
				},

				formHeight:0,
				//界面数据
				formdevice: {
					deviceId: 0,
					name: '',
					mnCode:'',
                    longitude:'',
					latitude:'',
					FactorIds:"",
					functionalAreaId:'',
					operationCompanyId:'',
					manufacturerName:'',
					operationCompanyPhone:'',
					operationCompanyCycle:'30',
					areaWeight:1,
					minuteFirstDate:new Date()
				},
				formProject:{
					project:''
				},
				type:'新增',
				
				picVisible:false,
				fileList: [],
				fileListShow:[],
				removeFileId:[],
				length:0,
				formFile:{
					deviceId:0,
					action:'uploadFile'
				},

				usertype:sessionStorage.getItem("type"),

				importVisible:false,
				ssrVisible:false,
				ssr:'0',
				mapType:'device',
				fatherUserId:1,
				areaList:[],
				operationcompanyList:[],
				paramVisible:false,
				paramsSys:[
					// { key:'SetStatTime',name:'统计分析时间(s)',value:'' },
					{ key:'StarRecLeq',devicekey:'StarRecLeq',name:'触发录音值(db)',value:'' },
					{ key:'RecTime',devicekey:'RecTime',name:'录音时长(s)',value:'' },
					{ key:'SelfCalTime',devicekey:'SelfCalTime',name:'自检开始时间',value:'' },
					{ key:'SCCycle',devicekey:'SCCycle',name:'自检频次(h)',value:'' },
					// { key:'AdRedMn',devicekey:'AdRedMn',name:'自检状态(1启动；0关闭)',value:'' },
				],
				paramsSysMapDevice:new Map(),
				sn:'',
				mn:'',
				controlType:'',
				url:window.configuration.controolUrl,
				defaultProps:{
					multiple: true,
					children: "children",
          			label: "name",
					value:"projectId"
				},
				defaultPropsSingle:{
					children: "children",
          			label: "name",
					value:"projectId"
				}
			}
		},
		methods: {
			clickBtn(type){
				if(type=="query"){
					this.getDevices();
				}else if(type=="add"){
					this.handleAdd();
				}else if(type=="setting"){
					this.showProject();
				}else if(type=="export"){
					this.exportExcle();
				}
			},
			showSsr(){
				this.ssrVisible=true;
			},
			showForm(index, row){
				if(row==1){//读取操作后的点击

				}else{//弹窗窗口后第一次读取
					this.mn=row.mnCode;
					this.controlType=row.controlType;
				}
				this.paramVisible=true;
				var param="";
				
				if(this.controlType=="1"||this.controlType==1){//设备直传
					this.getParams("all");
				}else if(this.controlType=="0"||this.controlType==0){//7000
					for(var i=0;i<this.paramsSys.length;i++){
						param+=",";
						param+=this.paramsSys[i].key;
					}
					let para={
						param:param,
						mn:this.mn
					};
					getParam(para).then((res) => {
						if(res.data.Result=="false"||res.data.Result==false){
							this.$message({
								message: "读取失败，请重试",
								type: 'error'
							})
							return;
						}
						var guidList=res.data.data;
						if(guidList.length>0){
							this.sn=guidList[0].sn;
							for(var i=0;i<this.paramsSys.length;i++){
								if(this.paramsSys[i].key=="SelfCalTime"){
									this.paramsSys[i].value=guidList[0][this.paramsSys[i].key]+":00";
								}else{
									this.paramsSys[i].value=guidList[0][this.paramsSys[i].key];
								}
							}
						}
					
					});
				}
			},
			readHandle(row){
				if(this.controlType=="1"||this.controlType==1){//设备直传
					this.getParams(row.devicekey);
				}else if(this.controlType=="0"||this.controlType==0){//7000
					this.readClick(row);
				}
			},
			writeHandle(row){
				if(this.controlType=="1"||this.controlType==1){//设备直传
					this.setParams(row);
				}else if(this.controlType=="0"||this.controlType==0){//7000
					this.writeClick(row);
				}
			},
			readClick(row){
				var params = new URLSearchParams();
				params.append('sn', this.sn);
                params.append('action', 'read');
                params.append('key', row.key);
				var _this=this;
				axios({
					headers: {
						'Content-Type': 'application/json; charset=UTF-8',
						'Access-Control-Allow-Origin': '*'
					},//设置跨域请求头
					method: "GET",//请求方式
					url: this.url,//请求地址
					params:params
				})
				.then(function(res) {
					if(res.data==true||res.data=="OK"||res.data.QnRtn=="1"){
						_this.showForm(0,1);
						_this.$message({
							message: '读取成功',
							type: 'success'
							});
						}
					else{
						_this.$message({
							message: '读取失败',
							type: 'error'
						});
					}
				})
				.catch(function(err) {
					console.log(err);
				});
			},
			writeClick(row){
				var params = new URLSearchParams();
				params.append('sn', this.sn);
                params.append('action', 'write');
                params.append('key', row.key);
				if(row.key=="SelfCalTime"){
					params.append('value', row.value.split("：")[0].split(":")[0]);
				}else{
					params.append('value', row.value);
				}
				var _this=this;
				axios({
					headers: {
						'Content-Type': 'application/json; charset=UTF-8',
						'Access-Control-Allow-Origin': '*'
					},//设置跨域请求头
					method: "GET",//请求方式
					url: this.url,//请求地址
					params:params
				})
				.then(function(res) {
					if(res.data==true||res.data=="OK"||res.data.QnRtn=="1"){
						_this.$message({
							message: '写入成功',
							type: 'success'
							});
						}
					else{
						_this.$message({
							message: '写入失败',
							type: 'error'
						});
					}
				})
				.catch(function(err) {
					console.log(err);
				});
			},
			setParams(row){
				var params = new URLSearchParams();
				params.append('mnStr', this.mn);
                params.append(row.devicekey, row.value);
				this.listLoading = true;
				setParams(params).then((res) => {
					this.listLoading = false;
					if(res.data.result=="true"||res.data.result==true){
						this.$message({
							message: '写入成功',
							type: 'success'
						})
						for(let key in res.data.datas){
							var index=this.paramsSysMapDevice.get(key);
							this.paramsSys[index]["value"]=res.data.datas[key];
						}
					}else{
						this.$message({
							message: "写入失败",
							type: 'error'
						})
					}
				});
			},
			getParams(param){
				var params = new URLSearchParams();
				params.append('mnStr', this.mn);
                params.append('params', param);
				this.listLoading = true;
				getParams(params).then((res) => {
					this.listLoading = false;
					if(res.data.result=="true"||res.data.result==true){
						//处理读取到的数据 datas : {ck_time: "10", ck_cyc: "24", rec_dur: "10"}
						for(let key in res.data.datas){
							var index=this.paramsSysMapDevice.get(key);
							this.paramsSys[index]["value"]=res.data.datas[key];
						}
					}else{
						this.$message({
							message: "写入失败",
							type: 'error'
						})
					}
				});
			},
			getOperationCompanyList(){
                if(this.operationcompanyList.length>0){
                    return;
                }
				getOperationCompanyList({}).then((res) => {
					if(res.data.result=="false"){
						this.$message({
							message: "数据查询失败，请重试",
							type: 'error'
						})
						return;
					}
					this.operationcompanyList = res.data.data;
				});
            },
			getFunctionalAreaList(){
				if(this.areaList.length==0){
				getFunctionalAreaList({}).then((res) => {
					this.areaList = res.data.data;
				});
				}
			},
			handleCurrentChange(val) {
				this.page=val;
				this.getDevices();
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.getDevices();
			},
			//获取数据列表
			getDevices() {
				let para = {
                    page: this.page,
                    limit:this.pageSize,
                    mnCode: this.filters.mnCode
				};

				if(this.filters.projectId!=""){
					para.projectIds=this.filters.projectId.toString()
				}

                this.listLoading = true;
				getDeviceList(para).then((res) => {
                    this.listLoading = false;
					this.total = res.data.data.total;
					this.devices = res.data.data.records;
				});
			},
			exportExcle(){
				let para = {
                    mnCode: this.filters.mnCode
				};
				if(this.filters.projectId!=""){
					para.projectIds=this.filters.projectId.toString()
				}
				downloadFileBlob(para);
			},
			selsChange: function (sels) {
                this.sels = sels;
			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					let para = {
						ids: row.deviceId.toString()
					 };
					deleteDevices(para).then((res) => {
						this.listLoading = false;
						let resData = res.data;
						if (resData.code == 200) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
						}else{
							this.$message({
								message: resData.msg,
								type: 'error'
							})
						}
						this.getDevices();
					});
				}).catch(() => {

				});
			},
			//显示修改界面
			handleEdit: function (index, row) {
				this.facShow=false;
				this.formVisible = true;
				if( this.$refs.formdevice!=undefined){
               		this.$refs.formdevice.resetFields();
				}
				this.type='修改';
				this.getDeviceTypes();
				this.getProjects();
				this.getFunctionalAreaList();
				this.getOperationCompanyList();
				this.formdevice = Object.assign({}, row);
			},
			//显示新增界面
			handleAdd: function () {
				this.facShow=false;
				this.formVisible = true;
				// if( this.$refs.formdevice!=undefined){
               	// 	this.$refs.formdevice.resetFields();
				// }
				this.type='新增'; 
				this.getDeviceTypes();
				this.getProjects();
				this.getFunctionalAreaList();
				this.getOperationCompanyList();
				this.formdevice.functionalAreaId=1;
				this.formdevice.operationCompanyId=1;
				this.formdevice.areaWeight=1;
				this.formdevice.operationCompanyCycle=30;
				this.formdevice.FactorIds="";
				this.formdevice.latitude=36.072358;
				this.formdevice.longitude=120.389445;
			},
			importExcle(){
				let formData = new FormData();
				if(this.fileList.length>0||this.removeFileId.length>0){
					var i=0;
					this.fileList.forEach(file=> {
						formData.append("files"+i, file);
						i++;
					});
					formData.append("action","importExcle");
					formData.append("fileLen",i);
					formData.append("mapType",this.mapType);
					//	走接口
					importExcle(formData).then(res => {
						this.fileList=[];
						this.fileListShow=[];
						let resData = res.data;
						this.picVisible=false;
						//此处重置文件中间存储变量是为了相同文件能够重复传递
						if (resData.Result != true) {
							this.$message({
								message: "导入修改失败",
								type: 'error'
							})}else{
								this.$message({
									message: '导入修改成功',
									type: 'success'
								});
								this.importVisible=false;
								this.getDevices();
							}
						})
					.catch(err => {
						this.fileList=[];
						this.$message.success({
							message: "导入修改失败",
							type: 'error'
						});
					});	
				} 
			},
			GetDevicePic(id){
				let para = {
                    deviceId: id
				};
				getDevicePic(para).then((res) => {
					this.fileListShow=  res.data.data;
					this.fileListShow.forEach(element => {
						element.url=window.configuration.resourceUrlPhoto+element.urlName;
					});
				});
			},
			// 显示上传照片
			uploadPic:function(index, row){
				this.formFile.deviceId=row.deviceId;
				this.fileListShow=[];
				this.removeFileId=[];
				this.removeNewFile=[];
				this.picVisible=true;
				this.GetDevicePic(row.deviceId);
			},
			remove:function(file, fileList){
				if(file.id==undefined){
					var i=0;
					this.fileList.forEach(element => {
						if(element.uid==file.uid){
							this.fileList.splice(i, 1);
							return;
						}
						i++;
					});
				}else{
					this.removeFileId.push(file.id);
				}
			},
			change:function(file, fileList){
				//判断上传文件数量
				this.length=document.querySelector("input[type=file]").files.length;
				if(this.length>0){
					Array.from(document.querySelector("input[type=file]").files).forEach(file=>{
						if(this.fileList.indexOf(file) == -1){
							this.fileList.push(file);
						}
					})
				}
				return false;
			},
			httpRequest(){},
			submitUpload() {
				let formData = new FormData();
				if(this.fileList.length>0||this.removeFileId.length>0){
					var i=0;
					this.fileList.forEach(file=> {
						formData.append("files"+i, file);
						i++;
					});
					formData.append("deviceId",this.formFile.deviceId);

					if(this.removeFileId.length>0){
						formData.append("devicePicIds",this.removeFileId);
					}
					//	走接口
					uploadFile(formData).then(res => {
						this.fileList=[];
						this.fileListShow=[];
						let resData = res.data;
						this.picVisible=false;
						//此处重置文件中间存储变量是为了相同文件能够重复传递
						if (resData.code != 200) {
							this.$message({
								message: "上传失败",
								type: 'error'
							})}else{
								this.$message({
									message: '上传成功',
									type: 'success'
								});
							}
						})
					.catch(err => {
						this.fileList=[];
						this.$message.success({
							message: "上传失败",
							type: 'error'
						});
					});	
				} 
			},
			//查询设备类型信息
			getDeviceTypes() {
				this.listLoading = true;
				getDeviceTypes().then((res) => {
					this.deviceTypeList = res.data.data;
					this.listLoading = false;
				});
			},
			//查询项目信息
			getProjects() {
				this.listLoading = true;
                getProjects().then((res) => {
                    this.projectList=translateDataToTreeProject(res.data.data);
					this.projectAllList=res.data.data;
					this.listLoading = false;
				});
			},
            //Form表单提交
            submitData:function(){
                if(this.type=='修改'){
                   this.editSubmit();
                }else{
                     this.addSubmit();
                }
			},
			//添加
			addSubmit: function () {
				//如果开始时间超过三个月
				var d1 = new Date(this.formdevice.minuteFirstDate);
				var d2 = new Date();
				var days=parseInt(d2 - d1) / 1000 / 3600 / 24 ;
				if(days>90){
					this.$message({
						message: "选择开始时间超过90天",
						type: 'warn'
					})
					return;
				} 
				this.$refs.formdevice.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.loading = true;
							this.formdevice.minuteFirstDate=formatDate(this.formdevice.minuteFirstDate);
							let para = Object.assign({}, this.formdevice);
							para.mnCode=para.mnCode.trim();//去除空格
							para.projectId=para.projectId.toString();
                            addDevice(para).then((res) => {
								this.loading = false;
								let resData = res.data;
								if (resData.code == 200) {
									this.$message({
										message: '操作成功',
										type: 'success'
									});
								}else{
									this.$message({
										message: resData.msg,
										type: 'error'
									})
								}
                                this.formVisible = false;                                
                                this.getDevices();
                            }).catch((res) => {
								this.$message({
									message:  '操作失败',
									type: 'error'
								})
							});
						});
					}
				});
            },
            //修改
			editSubmit: function () {
				this.$refs.formdevice.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.loading = true;
                            let para = Object.assign({}, this.formdevice);
							para.projectId=para.projectId.toString();
                            updateDevice(para).then((res) => {
								this.loading = false;
								let resData = res.data;
								if (resData.code == 200) {
									this.$message({
										message: '操作成功',
										type: 'success'
									});
								}else{
									this.$message({
										message: resData.msg,
										type: 'error'
									})
								}
                                this.formVisible = false;                                
                                this.getDevices();
                            });
						});
					}
				});
			},
			showProject(){
				this.projectVisible=true;
			},
			//批量设置项目名称
			setProject: function () {
			
				var para=new URLSearchParams();
				para.append('deviceIds', this.sels.map(item => item.deviceId));
				para.append('projectId',this.formProject.project);

				setProject(para).then((res) => {
					this.listLoading = false;
					
					let resData = res.data;
					if (resData.code == 200) {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
					}else{
						this.$message({
							message: resData.msg,
							type: 'error'
						})
					}
					this.projectVisible=false;
					this.getDevices();
				});
            },
			setSSR(){
				var para=new URLSearchParams();
				para.append('deviceIds', this.sels.map(item => item.deviceId));
				para.append('ssr',this.ssr);

				setSSR(para).then((res) => {
					this.listLoading = false;
					
					let resData = res.data;
					if (resData.code == 200) {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
					}else{
						this.$message({
							message: resData.msg,
							type: 'error'
						})
					}
					this.ssrVisible=false;
					this.getDevices();
				});
			},
            //取消按钮
            cancleSubmit:function(){
				this.formVisible=false;
				this.projectVisible=false;
				this.gradeVisible=false;
				this.peopleVisible=false;
				this.picVisible=false;
				this.paramVisible=false;
				this.keyword='';

				this.fileList=[];

				this.importVisible=false;
				this.ssrVisible=false;
			},
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight+document.getElementsByClassName('toolbar')[1].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-120;
			}
		},
		mounted() {
			var user =JSON.parse(sessionStorage.getItem("user"));
			if(user==null){
				this.$message({
					message: "用户已离线，请重新登录",
					type: 'error'
				})
				this.$router.push({ path: '/login' });
				return;
			}else{
				this.fatherUserId=user.fatherUserId;
			}

			for (let index = 0; index < this.paramsSys.length; index++) {
				const element = this.paramsSys[index];
				this.paramsSysMapDevice.set(element.devicekey,index);
			}

			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)                                                 
			this.getDevices();
			this.getProjects(); 
		}
	}

</script>

<style scoped>
  

	#smallMapCon{
		float: left;
		width: 42%;
		margin-right: 2%;
		height: 350px;
	}
	#smallMap{
		width: 100%;
		height: 300px;
	}
	.dialog-footer{
		text-align: right;
	}
	.isShow{
		display: block;
	}
	.notShow{
		display: none;
	}


	
</style>


// WEBPACK FOOTER //
// Device.vue?04b6dd29